import React from 'react';
import { Alert, AlertTitle, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const PasswordWarningBanner = () => {
  const { showPasswordWarning, dismissPasswordWarning } = useAuth();

  if (!showPasswordWarning) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 64, // Below AppBar
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer - 1,
      }}
    >
      <Alert
        severity="warning"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={dismissPasswordWarning}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <AlertTitle>Security Warning</AlertTitle>
        You are using the default password. Please change your password immediately for security.
      </Alert>
    </Box>
  );
};

export default PasswordWarningBanner;